<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'100px'" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrderList.company')" prop="logisticsCompany">
            <BjSelectLov v-model="queryParams.logisticsCompany" :option-list="companyList" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.YearWeek')" prop="week">
            <el-date-picker id="getWeekDate2" v-model="weekDataNow1" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="changeWeek1">
        </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsCom.invoiceNo')" prop="invoiceNumber">
            <BjInput v-model="queryParams.invoiceNumber" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="$refs.ExcelImport.show()">{{
            $t('BusinessPurchaseSupplierShop.export.excelImport')
          }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'recoveryStatus'">{{ scope.row[col.prop]?$t('BusinessPurchaseComponentsCom.Recovered'):$t('BusinessPurchaseComponentsCom.NotRecovered') }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="onView(scope.row)">{{ $t('viewText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <ExcelImportDialog2 ref="ExcelImport" @reFresh="$refs.BjPage.onSearch()" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import ExcelImportDialog2 from './ExcelImportDialog2';

export default {
  name: 'BusinessOrderSend',
  components: { ExcelImportDialog2 },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      queryApi: orderApi.getOrderPostageList,
      queryParamsTime_create: [],
      // 查询参数
      queryParams: {
        invoiceNumber: '',
        logisticsCompany: '',
        startCreationDate: null,
        endLastUpdateDate: null,
        week: ''
      },
      companyList: [
          {label: 'AUSP', value: 'AUSP'},
          {label: 'HUNT', value: 'HUNT'},
          {label: 'ALLI', value: 'ALLI'},
          {label: 'COPL', value: 'COPL'},
          {label: 'DIFE', value: 'DIFE'},
          {label: 'ARMX', value: 'ARMX'},
      ],
      labelList: [
        { label: this.$t('InternalOrderList.company'), prop: 'logisticsCompany', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseComponentsCom.invoiceNo'), prop: 'invoiceNumber', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseComponentsCom.RecoveryStatus'), prop: 'recoveryStatus', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Date'), prop: 'invoiceDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.YearWeek'), prop: 'week', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Amount'), prop: 'invoiceAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.erpAmount'), prop: 'erpAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.totalDifference'), prop: 'totalDifference', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Operator2'), prop: 'createdName', isCheck: true, disabled: false },
        { label: this.$t('billingPage.OrderPostagecreate'), prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false},
      ],
      weekDataNow1:''
    };
  },
  computed: {},
  watch: {
    queryParamsTime_create(v) {
      this.queryParams.startCreationDate = (v || [])[0];
      this.queryParams.endLastUpdateDate = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    changeWeek1() {
      this.$nextTick(() => {
        this.queryParams.week = document.querySelector('#getWeekDate2').value;
      });
    },
    onView(row) {
        this.$router.push({
            name: 'BusinessOrderPostagDetail',
            query: { id: row.id },
        });
    },
    onDelete(row) {
        orderApi.delOrderPostageList({id: row.id}).then(res => {
            if (res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                    this.handleQuery();
                }, 500);
            }
        });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
        this.queryParamsTime_create = null;
        this.weekDataNow1 = ''
        return new Promise(resolve => {
            resolve();
        });
    },
  },
};
</script>
